module.exports = __webpack_public_path__ + "img/icon-plus.44ac3c88.svg";